import * as React from "react";
import { cn } from "./utils";

type TabsContextValue = { value?: string; onValueChange?: (v: string) => void };
const TabsContext = React.createContext<TabsContextValue>({});

export const Tabs = ({
  value,
  onValueChange,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & TabsContextValue) => (
  <TabsContext.Provider value={{ value, onValueChange }}>
    <div {...props}>{children}</div>
  </TabsContext.Provider>
);

export const TabsList = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
);

export const TabsTrigger = ({
  value,
  children,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { value: string }) => {
  const { value: active, onValueChange } = React.useContext(TabsContext);
  const isActive = active === value;

  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
        isActive
          ? "bg-background text-foreground shadow-sm"
          : "text-muted-foreground",
        className,
      )}
      onClick={() => onValueChange?.(value)}
      {...props}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({
  value,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { value: string }) => {
  const { value: active } = React.useContext(TabsContext);
  if (active !== value) return null;
  return <div {...props}>{children}</div>;
};
